(ns frontend.view.grid.counterparty-diligence-grid.project.columns)

;;default set of selected columns
(def ordered-default-columns
  [:project-counterparty-diligence/project-name
   :counterparty-diligence/status
   :project-counterparty-diligence/template
   :counterparty-diligence/note])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:project-counterparty-diligence/project-name})
